import React from "react";
import { useInView } from 'react-intersection-observer';

import ProjectIntroduction from "./ProjectIntroduction"
import Cover from "./Cover";
import ImageIntroduction from "./ImageIntroduction"
import StepPage from "./StepPage";

function Home() {
    const [coverRef, coverInView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
        rootMargin: '-50px 0px'
    });

    const [introRef, introInView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
        rootMargin: '-50px 0px'
    });

    const [imageRef, imageInView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
        rootMargin: '-50px 0px'
    });

    const [stepRef, stepInView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
        rootMargin: '-50px 0px'
    });

    return (
      <>
        <div className={'home'}>
            <div ref={coverRef} className={`section-card-wrapper ${coverInView ? 'section-visible' : ''}`}>
                <Cover></Cover>
            </div>
            <div ref={introRef} className={`section-card-wrapper ${introInView ? 'section-visible' : ''}`}>
                <ProjectIntroduction></ProjectIntroduction>
            </div>
            <div ref={imageRef} className={`section-card-wrapper ${imageInView ? 'section-visible' : ''}`}>
                <ImageIntroduction></ImageIntroduction>
            </div>
            <div ref={stepRef} className={`section-card-wrapper ${stepInView ? 'section-visible' : ''}`}>
                <StepPage></StepPage>
            </div>
        </div>
      </>
    )
}
  
export default Home